<template>
  <div class="map">
    <vl-map
      @mounted="onMapMounted"
      :load-tiles-while-animating="true"
      :load-tiles-while-interacting="true"
      data-projection="EPSG:4326"
      ref="map"
      style="height: calc(100vh - 200px)"
      :controls="false"
    >
      <vl-view :zoom.sync="zoom" :center.sync="center" :rotation.sync="rotation"></vl-view>

      <vl-interaction-select
        :features.sync="selectedFeatures"
        :multi="true"
        v-if="drawType == null"
        :hit-tolerance="10"
        ref="interaction"
      >
        <template slot-scope="select">
          <vl-style-box>
            <vl-style-stroke color="#423e9e" :width="7"></vl-style-stroke>
            <vl-style-fill :color="[254, 178, 76, 0.7]"></vl-style-fill>
            <vl-style-circle :radius="5">
              <vl-style-stroke color="#423e9e" :width="7"></vl-style-stroke>
              <vl-style-fill :color="[254, 178, 76, 0.7]"></vl-style-fill>
            </vl-style-circle>
          </vl-style-box>
          <vl-style-box :z-index="1">
            <vl-style-stroke color="#d43f45" :width="2"></vl-style-stroke>
            <vl-style-circle :radius="5">
              <vl-style-stroke color="#d43f45" :width="2"></vl-style-stroke>
            </vl-style-circle>
          </vl-style-box>

          <vl-overlay
            class="feature-popup"
            v-if="select.features.length"
            :position="pointOnSurface(select.features[0].geometry)"
            :positioning="'center-center'"
            :auto-pan="true"
            :auto-pan-animation="{ duration: 300 }"
          >
            <template v-if="select.features.length && markerSelected(select.features)">
              <section class="card">
                <header class="card-header">
                  <p class="card-header-title">Emergenza #{{ select.features[0].properties.id }}</p>
                  <a class="card-header-icon" title="Close" @click="selectedFeatures = []">
                    <i class="fas fa-times" aria-hidden="true"></i>
                  </a>
                </header>
                <div class="card-content">
                  <strong>Operatore:</strong>
                  {{ select.features[0].properties.warning_user }}
                  <br />
                  <strong>#{{ select.features[0].properties.id }} {{select.features[0].properties.name}}</strong>
                  <br />
                  <strong>Sopralluogo:</strong>
                  {{ select.features[0].properties.timestamp | moment }}
                  <br />
                  <strong>Lat:</strong>
                  {{ select.features[0].properties.coordinates[1] }}
                  <br />
                  <strong>Lon:</strong>
                  {{ select.features[0].properties.coordinates[0] }}
                  <br />
                  <strong>Descrizione:</strong>
                  <br />
                  {{ select.features[0].properties.description }}
                  <br />
                  <br />
                  <strong>Dati supplimentari</strong>
                  <br />
                  Persone coinvolte: {{ select.features[0].properties.affected_people }}
                  <br />
                  Gravità condizioni persone: {{ select.features[0].properties.people_state }}
                  <br />
                  Edifici coinvolti: {{ select.features[0].properties.affected_structures }}
                  <br />
                  Tipologia edifici: {{ select.features[0].properties.structures_type }}
                  <br />
                </div>
                <footer class="modal-card-foot">
                  <button
                    class="button is-success"
                    @click.prevent="openEmergency( select.features[0].properties )"
                  >Comunicazioni</button>
                  <button
                    class="button is-danger"
                    @click.prevent="resolveEmergency( select.features[0] )"
                    :class="{'is-loading': resolvingEmergency}"
                  >Risolvi</button>
                </footer>
              </section>
            </template>
            <template v-if="select.features.length && !markerSelected(select.features)">
              <section class="card">
                <header class="card-header">
                  <p class="card-header-title">Aggiorna indice di rischio</p>
                  <a class="card-header-icon" title="Close" @click="selectedFeatures = []">
                    <i class="fas fa-times" aria-hidden="true"></i>
                  </a>
                </header>
                <div
                  class="has-text-centered fullwidth"
                >Nuovo indice di rischio per le celle selezionate</div>
                <div class="card-content">
                  <div class="field is-horizontal">
                    <div class="field">
                      <input
                        type="radio"
                        id="level_green"
                        class="is-checkradio"
                        name="new-risk-index"
                        value="1"
                        v-model="new_risk_index"
                      />
                      <label class="radio" for="level_green">
                        &nbsp;&nbsp;
                        <i
                          style="color: rgb( 102, 255, 102 ); vertical-align: sub"
                          class="fa-2x fas fa-square"
                        ></i>&nbsp;&nbsp;
                        <span>Verde</span>
                      </label>
                    </div>
                    <div class="field">
                      <input
                        type="radio"
                        id="level_yellow"
                        class="is-checkradio"
                        name="new-risk-index"
                        value="2"
                        v-model="new_risk_index"
                      />
                      <label class="radio" for="level_yellow">
                        &nbsp;&nbsp;
                        <i
                          style="color: rgb( 255, 255, 153 ); vertical-align: sub"
                          class="fa-2x fas fa-square"
                        ></i>&nbsp;&nbsp;
                        <span>Giallo</span>
                      </label>
                    </div>
                    <div class="field">
                      <input
                        type="radio"
                        id="level_orange"
                        class="is-checkradio"
                        name="new-risk-index"
                        value="3"
                        v-model="new_risk_index"
                      />
                      <label class="radio" for="level_orange">
                        &nbsp;&nbsp;
                        <i
                          style="color: rgb( 255, 102, 0 ); vertical-align: sub"
                          class="fa-2x fas fa-square"
                        ></i>&nbsp;&nbsp;
                        <span>Arancione</span>
                      </label>
                    </div>
                    <div class="field">
                      <input
                        type="radio"
                        id="level_red"
                        class="is-checkradio"
                        name="new-risk-index"
                        value="4"
                        v-model="new_risk_index"
                      />
                      <label class="radio" for="level_red">
                        &nbsp;&nbsp;
                        <i
                          style="color: rgb( 255, 0, 0 ); vertical-align: sub"
                          class="fa-2x fas fa-square"
                        ></i>&nbsp;&nbsp;
                        <span>Rosso</span>
                      </label>
                    </div>
                    <div class="field">
                      <div class="control">
                        <button
                          @click.prevent="updateFeatures(selectedFeatures)"
                          class="button is-primary"
                        >Salva</button>
                      </div>
                    </div>
                  </div>
                  <table class="table is-bordered is-fullwidth alert-table">
                    <thead>
                      <tr>
                        <td>Allerta</td>
                        <td>Cosa può succedere</td>
                        <td>Fase operativa</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="alert-sign alert-sign-yellow">Gialla</td>
                        <td>
                          Smottamenti, colate di fango, caduta massi.
                          <br />Strade e ferrovie interrotte.
                          <br />Interruzione servizi di acqua, luce, gas e telefonia
                        </td>
                        <td>
                          Verifica la reperibilità dei componenti del Centro Operativo Comunale (COC);
                          <br />Verifica la disponibilità del volontariato comunale;
                          <br />Verifica la disponibilità delle risorse logistiche (mezzi e attrezzature);
                          <br />Valuta l’opportunità di attivare il COC.
                        </td>
                      </tr>
                      <tr>
                        <td class="alert-sign alert-sign-orange">Arancione</td>
                        <td>
                          Frane.
                          <br />Danni ad argini e ponti.
                          <br />Voragini.
                          <br />Pericolo per la sicurezza delle persone con possibili perdite di vite umane.
                        </td>
                        <td>
                          Attiva il COC, anche in forma ridotta;
                          <br />Avvia il coordinamento con gli Enti sovraordinati;
                          <br />Attua il monitoraggio sul territorio con volontariato comunale;
                          <br />Garantisce l’informazione alla popolazione;
                          <br />Ricognizione delle persone non autosufficienti in emergenza;
                          <br />Attivazione e gestione di misure preventive per il contrasto di eventuali effetti sul territorio (interruzioni o limitazioni stradali nei sottopassi, ponti sormontabili, viabilità interessata da movimenti franosi, ecc.).
                        </td>
                      </tr>
                      <tr>
                        <td class="alert-sign alert-sign-red">Rossa</td>
                        <td>
                          Frane profonde e di grandi dimensioni.
                          <br />Grave pericolo per la sicurezza delle persone con possibili perdite di vite umane.
                        </td>
                        <td>
                          Piena operatività del Sistema comunale di Protezione Civile.
                          <br />Impiego delle risorse della propria struttura e incrementando le attività di monitoraggio, sorveglianza e gestione di situazioni emergenziali.
                          <br />Attivazione delle misure di salvaguardia con lo sgombero delle persone dalle aree a rischio e l’interdizione di tali aree;
                          <br />Provvede alla salvaguardia delle persone e dei beni, fornendo, ove necessario, soccorso ed assistenza della popolazione.
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <textarea class="textarea" v-bind.sync="new_index_text"></textarea>
                </div>
              </section>
            </template>
          </vl-overlay>
        </template>
      </vl-interaction-select>

      <vl-layer-tile
        v-for="layer in baseLayers"
        :key="layer.name"
        :id="layer.name"
        :visible="layer.visible"
      >
        <component :is="layer.source.cmp" v-bind="layer" :crossOrigin="'anonymous'"></component>
      </vl-layer-tile>

      <vl-layer-vector v-bind="ms_layer">
        <vl-source-vector
          :loader-factory="loaderFactory"
          v-bind="ms_layer.source"
          :crossOrigin="'anonymous'"
        ></vl-source-vector>
        <vl-feature
          v-for="feature in ms_layer.source.staticFeatures"
          :key="feature.id"
          :id="feature.id"
          :properties="feature.properties"
        >
          <component :is="geometryTypeToCmpName(feature.geometry.type)" v-bind="feature.geometry"></component>
        </vl-feature>

        <component v-for="(style, i) in ms_layer.style" :key="i" :is="style.cmp" v-bind="style">
          <component v-for="(st, cmp) in ms_layer.styles" :key="cmp" :is="cmp" v-bind="st">
            <vl-style-fill v-if="st.fill" v-bind="st.fill"></vl-style-fill>
            <vl-style-stroke v-if="st.stroke" v-bind="st.stroke"></vl-style-stroke>
          </component>
        </component>
      </vl-layer-vector>

      <vl-layer-tile v-bind="frane_iano">
        <vl-source-wms
          v-bind="frane_iano.source"
          :crossOrigin="'anonymous'"
        ></vl-source-wms>

      </vl-layer-tile>

      <vl-layer-vector v-bind="emergency_markers">
        <vl-source-vector v-bind="emergency_markers.source">
          <vl-feature
            v-for="(feature, id) in emergency_markers.source.features"
            :key="id"
            :id="id"
            :properties="feature.properties"
          >
            <vl-geom-point :coordinates="feature.geometry"></vl-geom-point>
            <vl-style-box>
              <vl-style-text
                :font="emergency_markers.style.font"
                :text="emergency_markers.style.text"
                :text-baseline="emergency_markers.style.textBaseline"
              >
                <vl-style-fill
                  v-if="emergency_markers.style.fill"
                  v-bind="emergency_markers.style.fill"
                ></vl-style-fill>
                <vl-style-stroke
                  v-if="emergency_markers.style.stroke"
                  v-bind="emergency_markers.style.stroke"
                ></vl-style-stroke>
              </vl-style-text>
            </vl-style-box>
          </vl-feature>
        </vl-source-vector>
      </vl-layer-vector>

      <vl-overlay v-if="overlayMarker" :position="overlayMarker" :positioning="'bottom-center'">
        <template>
          <div class="overlay-content">
            <i class="fas fa-2x fa-map-marker-alt" style="color: #209cee"></i>
          </div>
        </template>
      </vl-overlay>
    </vl-map>
    <div class="base-layers-panel">
      <div class="buttons has-addons is-centered">
        <button
          class="button is-light"
          :class="{ 'is-info': baseLayers.bingmaps.visible && baseLayers.bingmaps.imagerySet == 'Aerial' }"
          @click="showBaseLayer('bingmaps', 'Aerial', 'Ortofoto')"
        >Ortofoto</button>
        <button
          class="button is-light"
          :class="{ 'is-info': baseLayers.bingmaps.visible &&  baseLayers.bingmaps.imagerySet == 'RoadOnDemand' }"
          @click="showBaseLayer('bingmaps', 'RoadOnDemand', 'Stradario')"
        >Stradario</button>
        <button
          class="button is-light"
          :class="{ 'is-info': baseLayers.lidar.visible }"
          @click="showBaseLayer('lidar', '', 'LIDAR')"
        >LIDAR</button>
        <button
          class="button is-light"
          :class="{ 'is-info': Object.keys( baseLayers ).every( ( l ) => baseLayers[ l ].visible == false ) }"
          @click="showBaseLayer('', '', '')"
        >Nessuno</button>
      </div>
    </div>
  </div>
</template>

<script>
import {
  createProj,
  addProj,
  findPointOnSurface,
  createStyle,
  createMultiPointGeom,
  loadingBBox
} from "vuelayers/lib/ol-ext";

import GeoJSON from "ol/format/GeoJSON.js";
import { transform, getPointResolution, transformExtent } from "ol/proj.js";
import VectorSource from "ol/source/Vector.js";
import Feature from "ol/Feature";
import Point from "ol/geom/Point.js";
import ScaleLine from "ol/control/ScaleLine";
import FullScreen from "ol/control/FullScreen";
import OverviewMap from "ol/control/OverviewMap";
import Group from "ol/layer/Group";
import ZoomToExtent from "ol/control/ZoomToExtent";
import Zoom from "ol/control/Zoom";
import Attribution from "ol/control/Attribution";
import { Fill, Stroke, Style } from "ol/style.js";
import EventBus from "../event-bus.ts";
import { API_URL } from "@/http.ts";
import moment from "moment";

export default {
  components: {
    EventBus
  },
  filters: {
    moment: function(timestamp) {
      return moment.unix(timestamp).format("DD/MM/YYYY HH:mm");
    }
  },
  data: () => {
    return {
      selectedFeatures: [],
      selectedMarkers: [],
      overlayMarker: null,
      emergencies: [],
      zoom: 13,
      center: [16, 38],
      rotation: 0,
      drawType: undefined,
      extentControl: new ZoomToExtent(),
      attributionControl: new Attribution(),
      zoomControl: new Zoom(),
      baseLayers: {
        lidar: {
          name: "wms",
          cmp: "vl-layer-tile",
          title: "LIDAR",
          visible: false,
          source: {
            cmp: "",
            url:
              "http://wms.pcn.minambiente.it/ogc?map=/ms_ogc/WMS_v1.3/servizi-LiDAR/LIDAR_CALABRIA.map"
          },
          layers: "EL.LIDAR.CALABRIA.1x1.DSM_LAST",
          extParams: { TILED: true },
          serverType: "geoserver"
        },
        bingmaps: {
          name: "bingmaps",
          title: "Ortofoto",
          apiKey:
            "AlqY4L0HnlkZXdwBIX5UY-efOpgQRbIIaUC-tbQERW9K-VsF2VobKqkujWSzpy8G",
          imagerySet: "Aerial",
          source: {
            cmp: "vl-source-bingmaps"
          },
          visible: true
        }
      },
      ms_layer: {
        id: "risk_layer",
        title: "Matrice S",
        cmp: "vl-layer-vector",
        visible: true,
        source: {
          cmp: "vl-source-vector",
          url:
            API_URL + "emma/admin/risk_layer?type=polygon&size=100&category=ms"
        },
        category: "ms"
      },
      frane_iano: {
        id: "frane_iano",
        title: "Frane Ianò",
        cmp: "vl-layer-tile",
        visible: true,
        source: {
          cmp: "vl-source-wms",
          url:"https://dataset.rmsfiliera.it/geoserver/geonode/wms",
          layers: 'frane_2012',
          extParams: {
            'TILED': true
          },
          'serverType': 'geoserver',
        },
      },
      emergency_markers: {
        id: "emergency_markers",
        title: "Emergenze",
        cmp: "vl-vector-layer",
        source: {
          cmp: "vl-source-vector",
          features: []
        },
        zIndex: 1000,
        style: {
          size: "50",
          font: "30px FontAwesome",
          text: "\uf3c5",
          textBaseline: "bottom",
          fill: {
            color: "blue"
          },
          stroke: {
            color: "blue"
          }
        }
      },
      new_risk_index: null,
      new_index_text: "",
      resolvingEmergency: false
    };
  },
  methods: {
    openEmergency(emergency) {
      EventBus.$emit("open-emergency", emergency);
    },
    resolveEmergency(feature) {
      const emergency = feature.properties;
      this.resolvingEmergency = true;
      var self = this;
      this.$swal({
        title: "Attenzione",
        text: `Risolvere l'emergenza #${emergency.id} ${
          emergency.name
        } ${moment.unix(emergency.timestamp).format("DD/MM/YYYY HH:mm")}`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Annulla"
      })
        .then(result => {
          if (result.value) {
            self.$http
              .post(`/emma/admin/emergencies/${emergency.id}/close`)
              .then(response => {
                if (response.data.success) {
                  self.selectedFeatures = [];
                  const index_to_remove = self.emergency_markers.source.features.findIndex(
                    el => el.id == emergency.id
                  );
                  if( index_to_remove > -1 )
                    self.emergency_markers.source.features.splice(index_to_remove, 1);
                  self.$swal("OK", `L'emergenza è stata risolta`, "success");
                }
              });
          }
        })
        .finally(() => {
          self.resolvingEmergency = false;
        });
    },
    markerSelected(features) {
      const res =
        features.length &&
        "isMarker" in features[0].properties &&
        features[0].properties.isMarker;
      if (res && features.length > 1) this.$nextTick(() => features.splice(1));
      return res;
    },
    showBaseLayer(name, type, title) {
      let layer = Object.keys(this.baseLayers).find(
        layer_name => this.baseLayers[layer_name].visible
      );
      if (layer) this.baseLayers[layer].visible = false;
      if (name) {
        layer = this.baseLayers[name];
        layer.imagerySet = type;
        layer.title = title;
        layer.visible = true;
      }
    },
    loaderFactory: function(vm) {
      var self = this;
      return (extent, resolution, projection) => {
        extent = self.$refs.map.$view.calculateExtent(
          self.$refs.map.$map.getSize()
        );
        extent = transformExtent(
          extent,
          self.$refs.map.$view.getProjection(),
          projection
        );
        let url = vm.$source.getUrl();
        if (typeof url === "function")
          url = url(extent, resolution, projection);

        if (url == null || url === "") return [];

        let params = {};
        if (extent.every(val => isFinite(val))) params = { extent: extent };
        return self.$http
          .get(url, {
            params: params,
            transformResponse: res => {
              return res;
            }
          })
          .then(response => {
            if (!vm.$source) return [];
            return vm.$source.getFormat().readFeatures(response.data, {
              featureProjection: vm.viewProjection,
              dataProjection: vm.resolvedDataProjection
            });
          });
      };
    },
    pointOnSurface: findPointOnSurface,
    geometryTypeToCmpName(type) {
      return "vl-geom-" + kebabCase(type);
    },
    getRiskLayerStyle() {
      const stroke = new Stroke({
        color: "rgba(0,0,0,0.0)",
        width: 1
      });
      const green = [
        new Style({
          fill: new Fill({ color: "rgba(102, 255, 102, 0.4)" }),
          stroke: stroke
        })
      ];
      const yellow = [
        new Style({
          fill: new Fill({ color: "rgba(255, 255, 153, 0.4)" }),
          stroke: stroke
        })
      ];
      const orange = [
        new Style({
          fill: new Fill({ color: "rgba(255, 102, 0, 0.4)" }),
          stroke: stroke
        })
      ];
      const red = [
        new Style({
          fill: new Fill({ color: "rgba(255, 0, 0, 0.4)" }),
          stroke: stroke
        })
      ];
      const white = [
        new Style({
          fill: new Fill({ color: "rgba(255, 255, 255, 0.4" }),
          stroke: stroke
        })
      ];
      const risks = [white, green, yellow, orange, red];
      return feature => {
        const featVal = feature.get("RISK");
        return risks[featVal];
      };
    },
    async updateFeatures(features) {
      if (!features.length || !this.new_risk_index )
      {
        await this.$swal( 'Attenzione', 'Inserire tutte le informazioni necessarie', 'error');
        return;
      }
      var self = this;
      let data = new FormData();
      let geometries = features.map( ( feature ) => {
        if(!feature.id)
          return null
        var coords = self.$refs.map.getLayerById('risk_layer').getSource().getFeatureById(feature.id).getGeometry().getCoordinates();
        coords = coords.map( (coord) => coord.map((c) => transform(c, 'EPSG:3857', 'EPSG:4326'))).reverse();
        return { 'type': 'Polygon', 'coordinates': coords };
      }).filter(x => x);
      
      data.append( 'the_geom', JSON.stringify( geometries ) );
      data.append( 'size', 100 );
      data.append( 'risk', this.new_risk_index );
      data.append( 'notes', this.new_index_text );
      try {
        await this.$http({
          method: 'PUT',
          url: `/emma/admin/risk_layer`,
          data: data
        });
        await this.$swal('OK', 'Le informazioni sono state correttamente salvate', 'success');
        this.$set( this.$data, 'selectedFeatures', [] );
        features.forEach( (feature ) => self.$refs.map.getLayerById('risk_layer').getSource().getFeatureById(feature.id).set('RISK', self.new_risk_index));
        this.$refs.map.refresh();
      } catch (error) {
        this.$swal('Attenzione', 'Si è verificato un errore', 'error');
      }
    },
    onMapMounted: function() {
      this.$refs.interaction.$on( 'select', function( feature) {
        this.new_index_text = (feature && feature.feature) ? feature.feature.get('notes') : '';
      })
      
      // // Add map controls
      this.$refs.map.$view.setMaxZoom(19);
      this.$refs.map.$view.setMinZoom(4);
      var self = this;
      this.$http.get("/emma/admin/city_bbox").then(resp => {
        self.$data.center = resp.data.center;
        self.$data.extent = resp.data.bbox;
        if (resp.data.bbox)
          self.$nextTick(() => {
            self.$data.extentControl.extent = self.$refs.map.$map
              .getView()
              .calculateExtent(self.$refs.map.$map.getSize());
          });
      });
      this.$data.ms_layer.style = [
        {
          cmp: "vl-style-func",
          factory: this.getRiskLayerStyle
        }
      ];
      this.$data.attributionControl.setCollapsed(false);
      this.$data.attributionControl.setCollapsible(true);
      this.$refs.map.$map
        .getControls()
        .extend([
          this.$data.attributionControl,
          this.$data.zoomControl,
          new ScaleLine(),
          this.$data.extentControl
        ]);
      this.$refs.map.refresh();
      EventBus.$on("emergency-load-complete", emergencies => {
        emergencies.forEach(emergency => {
          if (
            !self.emergency_markers.source.features.find(
              el => el.id == emergency.id
            )
          ) {
            self.emergency_markers.source.features.push({
              id: emergency.id,
              geometry: [emergency.coordinates[1], emergency.coordinates[0]],
              properties: { ...emergency, isMarker: true },
              style: self.markerStyle
            });
          }
        });
      });

      EventBus.$on("new-emergency", emergency => {
        self.emergency_markers.features.push(
          new Feature({
            ...emergency,
            geometry: [emergency.coordinates[1], emergency.coordinates[0]],
            isMarker: true,
            style: self.markerStyle
          })
        );
      });

      EventBus.$on("display-on-map", message => {
        self.$data.center = [message.coordinates[1], message.coordinates[0]];
        if (!("warning_user" in message))
          self.$data.overlayMarker = [
            message.coordinates[1],
            message.coordinates[0]
          ];
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.base-layers-panel {
  position: absolute;
  top: 200px;
  right: 40%;
  z-index: 5;
}

.feature-popup {
  min-width: 800px;
}

.alert-table {
  font-size: 9pt;
}

.alert-sign {
  padding: 20px;
  vertical-align: middle;
  text-align: center;
}

.alert-sign-yellow {
  background-color: rgb(255, 255, 153);
}

.alert-sign-orange {
  background-color: rgb(255, 102, 0);
}

.alert-sign-red {
  background-color: red;
}
</style>
